import schema from 'async-validator';
import React, { useState } from 'react';

const FormValidator = ({
  children,
  initialData = {},
  descriptor,
  onSubmit,
  key,
}) => {
  const [formData, setFormData] = useState(initialData);
  const [errors, setErrors] = useState({});

  const setFormValue = (key, value) => {
    setFormData({ ...formData, [key]: value });

    const err = validateValues({ [key]: value });

    if (Object.keys(err).length > 0) {
      setErrors({ ...errors, ...err });
    } else {
      const newErrors = { ...errors };
      delete newErrors[key];

      setErrors(newErrors);
    }
  };

  const setFormValues = (values) => {
    setFormData({ ...formData, ...values });
  };

  const validateValues = (data) => {
    let validator = new schema({});

    if (data) {
      const key = Object.keys(data)[0];
      const fieldDescriptor = descriptor[key];

      if (fieldDescriptor) {
        validator = new schema({ [key]: fieldDescriptor });
      }
    } else {
      validator = new schema(descriptor);
    }

    const fieldErrors = {};

    validator.validate(data || formData, (errs) => {
      if (errs) {
        errs.forEach((err) => {
          fieldErrors[err.field] = err.message;
        });
      }
    });

    return fieldErrors;
  };

  const handleSubmit = (ev) => {
    ev.preventDefault();
    const fieldErrors = validateValues();

    setErrors(fieldErrors);
    onSubmit(
      ev,
      {
        errors: Object.keys(fieldErrors).length > 0 ? fieldErrors : null,
        formData,
      },
    );
  };

  const childProp = {
    formData,
    setFormValue,
    setFormValues,
    validateValues,
    handleSubmit,
    errors,
    key,
  };

  return (
    <React.Fragment>
      {typeof children === 'function' ?
        (
          children(childProp)
        ) : (
          React.cloneElement(React.Children.only(children), childProp)
        )
      }
    </React.Fragment>
  );
};

export default FormValidator;
